module.exports = __webpack_public_path__ + "static/img/PSD16-S.321d8b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSD16-S.png
// module id = Iynp
// module chunks = 1